// src/hooks/useInactivityLogout.js
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const INACTIVITY_TIMEOUT = 10 * 60 * 1000; // 5 minutes in milliseconds

const useInactivityLogout = () => {
    const inactivityTimeoutRef = useRef(null);
    const navigate = useNavigate();

    const resetInactivityTimer = () => {
        clearTimeout(inactivityTimeoutRef.current);
        inactivityTimeoutRef.current = setTimeout(handleLogout, INACTIVITY_TIMEOUT);
    };

    const handleLogout = () => {
        localStorage.clear();
        window.location.href = '/login'; // Force full reload to clear React state
        //navigate('/login');
    };

    useEffect(() => {
        const events = ['mousemove', 'mousedown', 'keypress', 'scroll', 'touchstart'];
        events.forEach(event => {
            window.addEventListener(event, resetInactivityTimer);
        });
        resetInactivityTimer(); // Initial call

        return () => {
            clearTimeout(inactivityTimeoutRef.current);
            events.forEach(event => {
                window.removeEventListener(event, resetInactivityTimer);
            });
        };
    }, [navigate]);

    return resetInactivityTimer; // Return the reset function for use elsewhere
};

export default useInactivityLogout;